export const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8001';
export const SIGNUP_ENDPOINT = '/api/v1/user/create';
export const LOGIN_ENDPOINT = '/api/v1/user/login';
export const PAYMENT_AMOUNT_ENDPOINT = '/api/v1/payment/amount';
export const SUBSCRIPTION_STATUS_ENDPOINT = '/api/v1/user/subscription-status';
export const CANCEL_SUBSCRIPTION_ENDPOINT = '/api/v1/subscription/cancel';
export const PAYMENT_HISTORY_ENDPOINT = '/api/v1/payment/history';
export const VERIFY_SESSION_ENDPOINT = '/api/v1/payment/verify-session';
export const USAGE_ENDPOINT = '/api/v1/user/usage';
export const THREAD_CATEGORIES_ENDPOINT = '/api/v1/threads/categories';
export const THREAD_CATEGORY_ENDPOINT = '/api/v1/threads/category';
export const THREAD_CATEGORIES_UPDATE_ENDPOINT = '/api/v1/threads';
